import { Component, Input } from '@angular/core'
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { CmmsItemModalComponent } from '../cmms-item-modal/cmms-item-modal.component'

@Component({
  selector: 'app-notification-list-items-modal',
  templateUrl: './notification-list-items-modal.component.html',
  styleUrl: './notification-list-items-modal.component.scss',
  standalone: false,
})
export class NotificationListItemsModalComponent {
  @Input({ required: true }) items: {
    name: string
    title: string
    url: string
    status?: number
  }[] = []

  constructor(
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
  ) {}

  public onNotificationModalOpen(item: {
    name: string
    title: string
    url: string
    status?: number
  }): void {
    this.activeModal.close()

    const modalRef: NgbModalRef = this.modalService.open(CmmsItemModalComponent, { size: 'md' })
    modalRef.componentInstance.type = 'NO'
    modalRef.componentInstance.item = item
    modalRef.result.then((result) => {}).catch((res) => {})
  }

  public cancel(): void {
    this.activeModal.dismiss({})
  }
}

